import { ClientGraphqlError } from "backend/fetcher";

const USER_FACING_ERROR_TYPES = [
    "QUICKBOOKS_UNAVAILABLE",
    "QUICKBOOKS_UNCONFIRMED_WRITE",
    "QUICKBOOKS",
    "CREDENTIAL_DISCONNECTED",
];

export function quickBooksErrorText(error: unknown, fallback: string): string {
    if (!(error instanceof ClientGraphqlError)) {
        return fallback;
    }
    return error.messageForErrorTypes(USER_FACING_ERROR_TYPES) ?? fallback;
}
